import theme from '~/styles/theme';

const customStyles = (size) => ({
  container: (provided) => ({
    ...provided,
    fontSize: size === 'sm' ? theme.fontSizes.sm : theme.fontSizes.md,
    // Fix for Safari iOS so it doesn't zoom in on focus
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: theme.fontSizes.lg,
    },
  }),
  dropdownIndicator: (provided, { selectProps }) => ({
    ...provided,
    color: theme.colors.primary[500],
    transform: selectProps.menuIsOpen && 'rotate(180deg)',
    padding: size === 'sm' ? 0 : provided.padding,
  }),
  control: (provided, { isFocused, selectProps }) => ({
    ...provided,
    borderColor: selectProps.hasError
      ? theme.colors.error[500]
      : isFocused
        ? theme.colors.primary[500]
        : theme.colors.gray[400],
    borderRadius: theme.radii.full,
    boxShadow: isFocused && 'none',
    minHeight: size === 'sm' ? 'auto' : '2.5rem',
    '&:hover': {
      borderColor: isFocused
        ? theme.colors.primary[500]
        : theme.colors.gray[400],
    },
  }),
  option: (provided, { isSelected, isFocused, isDisabled }) => ({
    ...provided,
    cursor: isDisabled ? 'initial' : 'pointer',
    backgroundColor: isFocused ? theme.colors.gray[50] : 'transparent',
    color: isDisabled
      ? theme.colors.gray[400]
      : isSelected
        ? theme.colors.primary[500]
        : isFocused
          ? theme.colors.primary[500]
          : 'inherit',
    ':active': {
      backgroundColor:
        !isDisabled &&
        (isSelected ? theme.colors.primary[500] : theme.colors.gray[50]),
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: size === 'sm' ? '6px 8px' : '6px 13px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingRight: size === 'sm' ? theme.space[2] : theme.space[3],
    '&:hover svg': {
      fill: theme.colors.primary[500],
    },
  }),
  menu: (provided) => ({
    ...provided,
    boxShadow: theme.shadows.floating,
    borderRadius: 10,
    marginTop: theme.space[1],
    zIndex: theme.zIndices.dropdown,
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: 8,
    paddingBottom: 8,
  }),
});

export default customStyles;
